interface AiDataTableProps {
  headers: string[];
  rows: string[][];
}

export default function AiDataTable({ headers, rows }: AiDataTableProps) {
  if (!headers.length || !rows.length) return null;

  return (
    <div className="overflow-x-auto my-2 rounded-lg border border-theme-primary">
      <table className="min-w-full text-sm">
        <thead className="bg-surface-tertiary border-b-2 border-theme-primary">
          <tr>
            {headers.map((header, i) => (
              <th
                key={i}
                className="px-3 py-2 text-left text-xs font-heading font-semibold text-theme-secondary uppercase tracking-wider"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-theme-primary">
          {rows.map((row, ri) => (
            <tr key={ri} className="transition-colors duration-150 hover:bg-primary-50/50 dark:hover:bg-primary-950/20">
              {row.map((cell, ci) => (
                <td key={ci} className="px-3 py-2 text-theme-secondary whitespace-nowrap">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
